

import axios from "@/axios";

/**
 * Servicio para manejar la lógica relacionada con países
 */
class CountryService {
  /**
   * Obtiene todos los países desde la API
   * @returns {Promise<Array>} Lista de países
   */
  async getAllCountries() {
    try {
      const response = await axios.get("/countries");
      return response.data.data || [];
    } catch (error) {
      console.error("Error al obtener países:", error);
      return [];
    }
  }

  /**
   * Obtiene solo países específicos (PA, CR, GT)
   * @returns {Promise<Array>} Lista filtrada de países
   */
  async getAvailableCountries() {
    try {
      const countries = await this.getAllCountries();
      
      return countries.filter(country => {
        const name = country.name.toLowerCase();
        return (
          name.includes("panama") || 
          name.includes("panamá") || 
          name.includes("costa rica") || 
          name.includes("guatemala")
        );
      });
    } catch (error) {
      console.error("Error al filtrar países:", error);
      
      return [
        { id: 6, name: "Panamá", code: "PA" },
        { id: 5, name: "Costa Rica", code: "CR" },
        { id: 1, name: "Guatemala", code: "GT" }
      ];
    }
  }

  /**
   * Actualiza el país del usuario en el backend
   * @param {number} countryId ID del país
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async updateUserCountry(countryId) {
    try {
      const response = await axios.post("/v1/update-country", {
        country_id: countryId
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar país del usuario:", error);
      throw error;
    }
  }

  /**
   * Obtiene el código ISO del país a partir del nombre
   * @param {string} name Nombre del país
   * @returns {string} Código ISO de dos letras
   */
  getCountryCodeFromName(name) {
    const nameLower = name.toLowerCase();
    if (nameLower.includes("panama") || nameLower.includes("panamá")) return "pa";
    if (nameLower.includes("costa rica")) return "cr";
    if (nameLower.includes("guatemala")) return "gt";
    return "pa"; 
  }

  /**
   * Detecta el país del usuario mediante geolocalización
   * @returns {Promise<string>} Código ISO del país detectado
   */
  async detectUserCountry() {
    try {
      const response = await axios.get("https://api.country.is");
      return response.data.country.toLowerCase();
    } catch (error) {
      console.error("Error al detectar país:", error);
      return "pa"; 
    }
  }
}

export default new CountryService();